export const globalScripts = () => {};
export const globalStyles = "";
